"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paddingToCss = exports.marginToCss = exports.spacingToCss = exports.spacingTypes = void 0;
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
var spacingTypes;
(function (spacingTypes) {
    spacingTypes["all"] = "all";
    spacingTypes["bottom"] = "bottom";
    spacingTypes["horizontal"] = "horizontal";
    spacingTypes["left"] = "left";
    spacingTypes["right"] = "right";
    spacingTypes["top"] = "top";
    spacingTypes["vertical"] = "vertical";
})(spacingTypes = exports.spacingTypes || (exports.spacingTypes = {}));
/**
 * Dimensional Tests
 * key: dimension
 * value: tests array in priority order
 */
var dimensions = {
    Bottom: [spacingTypes.bottom, spacingTypes.vertical, spacingTypes.all],
    Left: [spacingTypes.left, spacingTypes.horizontal, spacingTypes.all],
    Right: [spacingTypes.right, spacingTypes.horizontal, spacingTypes.all],
    Top: [spacingTypes.top, spacingTypes.vertical, spacingTypes.all],
};
var resolveSpacing = function (value, defaultAmount) {
    // if true we want to use defaultAmount as the value
    if (value === true)
        return (constants_1.Spacing[defaultAmount] ||
            defaultAmount ||
            0);
    // If false always use 0 as value (using it as a clear)
    if (value === false)
        return 0;
    // Try to find a theme spacing
    return ((value && constants_1.Spacing[value]) ||
        value ||
        defaultAmount ||
        0);
};
var convertSpacings = function (spacingDef, defaultAmount, prop) {
    var spacings = Object.keys(spacingDef);
    return Object.keys(dimensions).reduce(function (acc, dim) {
        var _a;
        // look for any spacings that match the tests for the dimension
        var spacing = dimensions[dim].find(function (test) { return spacings.includes(test); });
        if (spacing) {
            // we found a matching spacing so apply it to the return
            return __assign(__assign({}, acc), (_a = {}, _a["" + prop + dim] = resolveSpacing(spacingDef[spacing], defaultAmount), _a));
        }
        // no matching spacing was found so don't add anything
        return acc;
    }, {});
};
/**
 * Converts spacing definitions to css-in-js spacings.
 */
/** @component */
exports.spacingToCss = function (prop) { return function (spacingDef, defaultAmount) {
    var _a, _b;
    if (defaultAmount === void 0) { defaultAmount = '20px'; }
    // Just return empty object if the spacing def wasn't supplied
    if (spacingDef === null || spacingDef === undefined)
        return {};
    if (lodash_1.isObject(spacingDef)) {
        // spacingDef is an object so we can just pass it through
        return convertSpacings(spacingDef, defaultAmount, prop);
    }
    // spacing def is a string / number / boolean
    if (spacingTypes[spacingDef]) {
        // spacingDef is one of the spacingTypes so use defaultAmount with it
        return convertSpacings((_a = {},
            _a[spacingDef] = true,
            _a), defaultAmount, prop);
    }
    else {
        // spacingDef is an unknown string / number / boolean so use it with 'all'
        return convertSpacings((_b = {},
            _b[spacingTypes.all] = spacingDef,
            _b), defaultAmount, prop);
    }
}; };
exports.marginToCss = exports.spacingToCss('margin');
exports.paddingToCss = exports.spacingToCss('padding');
